<template>
  <div class="perfect-bu-config" v-loading="loading">
    <ContentHeader :showBack="true" />
    <div class="content-container" style="padding-bottom: 20px;min-height: 0px">
      <div class="progress-Bar">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="待提交"></el-step>
          <el-step title="审批中"></el-step>
          <el-step title="生效中"></el-step>
          <el-step title="已结束"></el-step>
        </el-steps>
      </div>
    </div>
    <div class="content-container" style="padding-top: 0;padding-bottom: 0;">
      <div class="content-header">
        <h4>活动信息</h4>
        <div v-if="tradePerfectThemeDefineDTO.themeStatus === 100">
          <el-button size="mini" type="danger" @click="allPass(200)">通过</el-button>
          <el-button size="mini" type="danger" @click="allPass(0)">驳回</el-button>
        </div>
      </div>
      <div class="content">
        <div class="content-box">
          <div class="left">
            <div class="row">
              <div class="content-left">主题名称</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.themeName}}</div>
            </div>
            <div class="row">
              <div class="content-left">活动时间</div>
              <div
                class="content-right"
              >{{tradePerfectThemeDefineDTO.startDate | parseTime('{y}-{m}-{d}')}} 至 {{tradePerfectThemeDefineDTO.endDate | parseTime('{y}-{m}-{d}')}}</div>
            </div>
            <div class="row">
              <div class="content-left">陈列追踪方式</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.trackTypeNameScope}}</div>
            </div>
            <div class="row">
              <div class="content-left">陈列费</div>
              <div
                v-if="tradePerfectThemeDefineDTO.bonusFeeChooseType==='01'"
                class="content-right"
              >{{tradePerfectThemeDefineDTO.bonusFeeMin+' - '+tradePerfectThemeDefineDTO.bonusFeeMax}}元</div>
              <div v-else class="content-right">{{tradePerfectThemeDefineDTO.bonusFeeScope}}</div>
            </div>
            <div class="row">
              <div class="content-left">预算</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.budgetTypeId}}</div>
            </div>
          </div>
          <div class="right">
            <div class="row">
              <div class="content-left">渠道</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.channelName}}</div>
            </div>
            <div class="row">
              <div class="content-left">所属区域</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.orgName}}</div>
            </div>
            <div class="row">
              <div class="content-left">执行周数</div>
              <div
                v-if="tradePerfectThemeDefineDTO.execWeekChooseType==='01'"
                class="content-right"
              >{{tradePerfectThemeDefineDTO.execWeekMin+' - '+tradePerfectThemeDefineDTO.execWeekMax}}周</div>
              <div v-else class="content-right">{{tradePerfectThemeDefineDTO.execWeekScope}}</div>
            </div>
            <div class="row">
              <div class="content-left">费用返还方式</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.bonusTypeNameScope}}</div>
            </div>
            <div class="row">
              <div class="content-left">赠酒数/周 (箱)</div>
              <div
                v-if="tradePerfectThemeDefineDTO.bonusBeerChooseType==='01'"
                class="content-right"
              >{{tradePerfectThemeDefineDTO.bonusBeerMin+' - '+tradePerfectThemeDefineDTO.bonusBeerMax}}箱</div>
              <div v-else class="content-right">{{tradePerfectThemeDefineDTO.bonusBeerQtyScope}}</div>
            </div>
          </div>
        </div>
        <div class="row">
              <div class="content-left">赠酒SKU</div>
              <div class="content-right content-skuRight"><span v-for="item in bonusBeerScope" :key="item.skuCode">{{item.skuName}}</span></div>
        </div>
      </div>
      <div v-if="activeName !== ''">
      <h4>执行任务信息</h4>
      <!-- tab栏 -->
      <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
        <template v-for="item in taskCheckedList">
          <el-tab-pane v-if="item.checked" :key="item.key" :label="item.title" :name="item.title"></el-tab-pane>
        </template>
      </el-tabs>
      <!-- 选项卡 -->
      <div v-show="activeName==='堆箱任务'">
        <PerfectBuConfigDesign
        v-if="boxObj.mixinPackScopeList && boxObj.mixinPackScopeList.length > 0"
          ref="boxTask"
          class="tab-content"
          :type="'view'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="boxObj.mixinPackScopeList || []"
          :regionListByBu="regionListByBu"
        ></PerfectBuConfigDesign>
        <PerfectBuCombinationDesign
          v-if="boxObj.mixinDisplayScopeList && boxObj.mixinDisplayScopeList.length > 0"
          ref="boxCombination"
          :type="'view'"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'堆箱组合陈列套餐配置'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="boxObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
        ></PerfectBuCombinationDesign>
      </div>
      <div class="tab-content" v-show="activeName==='货架任务'">
        <PerfectBuFreezerDesign
          v-if="goodsShelfObj.mandatoryScopeList && goodsShelfObj.mandatoryScopeList.length > 0"
          ref="goodsShelfTask"
          :type="'view'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="goodsShelfObj.mandatoryScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
        ></PerfectBuFreezerDesign>
        <PerfectBuCombinationDesign
          v-if="goodsShelfObj.mixinDisplayScopeList && goodsShelfObj.mixinDisplayScopeList.length > 0"
          ref="goodsShelfCombination"
          :type="'view'"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'货架组合陈列套餐配置'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="goodsShelfObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
        ></PerfectBuCombinationDesign>
      </div>
      <div class="tab-content" v-show="activeName==='冰柜任务'">
        <PerfectBuFreezerDesign
          v-if="freezerObj.mandatoryScopeList && freezerObj.mandatoryScopeList.length > 0"
          ref="freezerTask"
          :type="'view'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="freezerObj.mandatoryScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
        ></PerfectBuFreezerDesign>
        <PerfectBuCombinationDesign
          v-if="freezerObj.mixinDisplayScopeList && freezerObj.mixinDisplayScopeList.length > 0"
          ref="freezerCombination"
          :type="'view'"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'冰柜组合陈列套餐配置'"
          :originThemeDefineDTO="tradePerfectThemeDefineDTO"
          :primaryData="freezerObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
        ></PerfectBuCombinationDesign>
      </div>
      </div>
    </div>
    <div class="content-container">
      <div class="content-header">
        <h4>操作记录</h4>
      </div>
      <div class="content-table">
        <el-table :data="tradePerfectThemeDefineDTO.commonProcessRecordDTOList" border style="width: 100%">
          <el-table-column label="操作人" align="center">
            <template #default="scope">
              {{scope.row.employeeLevelName + '-' + scope.row.processClientName}}
            </template>
          </el-table-column>
          <el-table-column prop="processActionName" label="操作" align="center"></el-table-column>
          <el-table-column prop="processRemark" label="备注" align="center"></el-table-column>
          <el-table-column prop="createDate" label="时间" align="center">
            <template #default="scope">
              <div>{{scope.row.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import PerfectBuConfigDesign from './components/perfect-bu-config-design'
import PerfectBuCombinationDesign from './components/perfect-bu-combination-design'
import PerfectBuFreezerDesign from './components/perfect-bu-freezer-design'
export default {
  name: 'perfect-bu-config',
  components: {
    ContentHeader,
    PerfectBuConfigDesign,
    PerfectBuCombinationDesign,
    PerfectBuFreezerDesign
  },
  data () {
    return {
      active: 0,
      themeDefineId: '',
      regionListByBu: [],
      tradePerfectThemeDefineDTO: {},
      boxObj: {}, // 修改堆箱默认数据
      goodsShelfObj: {}, // 修改货架默认数据
      freezerObj: {}, // 修改冰柜默认数据
      customBrandList: [], // 子品牌对应放入品牌数组中
      taskCheckedList: [],
      activeName: '堆箱任务',
      bonusBeerScope: []
    }
  },
  watch: {
    // 勾选任务
    taskCheckedList: {
      deep: true,
      immediate: true,
      handler () {
        for (let i = 0; i < this.taskCheckedList.length; i++) {
          if (this.taskCheckedList[i].checked) {
            this.activeName = this.taskCheckedList[i].title
            return
          }
        }
      }
    }
  },
  computed: {
  },
  created () {
    this.$store.dispatch('getDictByName', 'tradePerfectMandatorySpecsMap')
    this.$store.dispatch('getDictByName', 'tradePerfectScopeDetailSpecMap')
    this.themeDefineId = this.$route.query.themeDefineId
    this.getBuThemeDefineInfo()
  },
  methods: {
    // 获取默认数据
    getBuThemeDefineInfo () {
      this.loading = true
      tradeApi.getBuThemeDefineInfo({ themeDefineId: this.themeDefineId }).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.tradePerfectThemeDefineDTO = res.data.resultData.tradePerfectThemeDefineDTO || []
          this.taskCheckedList = []
          switch (this.tradePerfectThemeDefineDTO.themeStatus) {
            case 0:
              this.active = 0
              break
            case 100:
              this.active = 1
              break
            case 200:
              this.active = 2
              break
            case 900:
              this.active = 3
              break
          }
          if (!this.tradePerfectThemeDefineDTO.bonusBeerScope) {
            this.bonusBeerScope = []
          } else {
            this.bonusBeerScope = JSON.parse(this.tradePerfectThemeDefineDTO.bonusBeerScope)
          }
          if (this.tradePerfectThemeDefineDTO.taskTypeScope === '') {
            this.activeName = ''
          }
          this.tradePerfectThemeDefineDTO.taskTypeScope.split(',').forEach(item => {
            if (item === '01') {
              this.taskCheckedList.push({ title: '堆箱任务', key: item, checked: true, showTask: true })
            }
            if (item === '02') {
              this.taskCheckedList.push({ title: '货架任务', key: item, checked: true, showTask: true })
            }
            if (item === '03') {
              this.taskCheckedList.push({ title: '冰柜任务', key: item, checked: true, showTask: true })
            }
          })
          // 组建中已配置的数据
          this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList.forEach(item => {
            if (item.taskType === '01') {
              this.boxObj = item
            }
            if (item.taskType === '02') {
              this.goodsShelfObj = item
            }
            if (item.taskType === '03') {
              this.freezerObj = item
            }
          })
          let orgCode = this.tradePerfectThemeDefineDTO.orgCode ? this.tradePerfectThemeDefineDTO.orgCode : this.orgList[0].orgCode
          this.getRegionListByBu(orgCode)
          // 处理匹配品牌与子品牌
          let brandList = Object.assign([], this.tradePerfectThemeDefineDTO.brandList)
          let subBrandList = Object.assign([], this.tradePerfectThemeDefineDTO.subBrandList)
          if (brandList.length && subBrandList.length) {
            brandList.forEach(brand => {
              this.$set(brand, 'subBrandList', [])
              subBrandList.forEach(subBrand => {
                if (brand.abiBrandId === subBrand.parentBrandId) {
                  brand.subBrandList.push(subBrand)
                }
              })
            })
          }
          this.customBrandList = brandList
        }
      })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取区域列表
    getRegionListByBu (code) {
      let params = {
        buCode: code
      }
      this.$store
        .dispatch('getRegionListByBu', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.regionListByBu = res.data.resultData.regionList || []
            this.regionListByBu.forEach(item => {
              item.orgName = item.orgName.substring(0, item.orgName.indexOf('|'))
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    allPass (themeStatus) {
      let params = [{ themeDefineId: this.themeDefineId, themeStatus }]
      let mag = themeStatus === 200 ? '审批通过' : '驳回'
      this.$prompt('请输入' + mag + '原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (value === null && themeStatus === 0) {
          this.$message.warning('请输入驳回原因')
          return
        }
        params[0].processRemark = value
        tradeApi.perfectApproval(params).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success(mag + '成功')
            if (themeStatus === 200) {
              this.getBuThemeDefineInfo()
            } else {
              this.$router.push({ name: 'perfect-theme-approve' })
            }
          }
        })
      }).catch(() => {

      })
    },
    handleClick (tab, event) {
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #cd1231;
  border-color: #cd1231;
  font-weight: 400;
}
::v-deep .el-step__head.is-success,
::v-deep .el-step__head.is-process {
  font-size: 14px;
}
.clearStyle {
  line-height: 0px;
}
.content-container {
  h4 {
    font-weight: bold;
  }
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: space-between;
}
.content {
  // height: 320px;
  font-size: 14px;
  margin: 30px auto;
  padding: 0 40px;
  background-color: #fff;
  border-radius: 10px;
  line-height: 50px;
  .content-box {
    display: flex;
    .left{
      width: 50%;
    }
    .right{
      width: 50%;
    }
  }
  .row {
    display: flex;
    span{
      padding-right:15px;
    }
    .content-left {
      width: 130px;
    }
    .content-skuRight {
      width: 900px!important;
    }
  }
}
.content-table {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.tabs {
  margin-top: 20px;
}
// 任务多选样式
.task {
  display: flex;
  // justify-content: space-around;
  align-content: center;
  margin: 20px 20px;
  border-radius: 10px;

  .task-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    line-height: 45px;
    color: #333;
    overflow: hidden;
    text-align: center;

    .task-content {
      align-content: center;
      width: 30%;
      margin: 0 10px;
      height: 90px;
      background-color: #fff;
      border-radius: 10px;
      .task-title {
        font-size: 16px;
      }
    }
  }
}
.taskCheckbox {
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 50px;
    width: 25px;
    height: 25px;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox.is-bordered.is-checked {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep.el-checkbox__inner::after {
    height: 15px;
    left: 10px;
    top: 2px;
  }
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input .el-checkbox__inner {
    height: 25px;
    width: 25px;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input:hover .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
}
// // 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  margin: -15px auto 0;
  padding: 20px 20px;
  background-color: #fff;
  border-radius: 0px 10px 10px 10px;
}
.tab-combination {
  border-radius: 10px !important;
}
// 加号
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 12px 0 0 0;
  border-radius: 10px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}

.operate {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
.progress-Bar {
  background-color: #fff;
  padding: 20px 0;
}
// 必填
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}
</style>
